import heroSection from "../../components/heroSection/index.vue";
import categorieSection from "../../components/categorieSection/index.vue";
// import promoSection from "../../components/promoSection/index.vue";
import categorieProductSection from "../../components/categorieProductSection/index.vue";
import partnersSection from "../../components/partnersSection/index.vue";
import instagramSection from "../../components/instagramSection/index.vue";
import articleHomeSection from "../../components/articleHomeSection/index.vue";
import eventSection from "../../components/eventSection/index.vue";


export default {
  name: "homePage",
  components: {
    articleHomeSection,
    heroSection,
    categorieSection,
    // promoSection,
    categorieProductSection,
    partnersSection,
    instagramSection,
    eventSection
  },
};
